function Branding(){
    return (
        <div id="branding">
			<h1>Fleeting Communes</h1>
		</div>
    )
}

export default Branding;